<template>
  <div>
    <div class="row">
      <div class="col-md-12">
          <div class="center-block" v-if="kiosk.values">
            <!-- <chart :type="'bar'" :data="kioskData" :options="barsOptions" :height="60"></chart>
            <va-chart :data="verticalBarChartData" type="vertical-bar"></va-chart> -->
            <va-chart style="height: 200px;" type="vertical-bar" :data="kioskData" :options="barsOptions"></va-chart>
          </div>
          <div class="loading" v-else>
            <self-building-square-spinner
              :animation-duration="2500"
              :size="40"
              color="#29c4a9"
            />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SelfBuildingSquareSpinner } from 'epic-spinners'

export default {
  components: {
    SelfBuildingSquareSpinner
  },
  props: ['kiosk'],
  data () {
    return {
      barsOptions: {
        tooltips: {
          mode: 'label'
        },
        scales: {
          xAxes: [{
            // barPercentage: 2
            display: true,
            barThickness: 4,
            gridLines: {
              display: true
            }
          }],
          yAxes: [{
            display: true,
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }]
        }
      },
      labels: [],
      dataPresentations: [],
      dataQuestions: [],
      dataTests: [],
      dataPreContacts: [],
      dataContacts: []
    }
  },
  computed: {
    kioskData: function () {
      let data = {
        labels: this.labels,
        datasets: [
          {
            label: this.$t('kiosks.graph.users'),
            backgroundColor: '',
            data: this.dataPresentations
          },
          {
            label: this.$t('kiosks.graph.questionaries'),
            backgroundColor: '#5dceb3',
            data: this.dataQuestions
          },
          {
            label: this.$t('kiosks.graph.tests'),
            backgroundColor: '#ffc000',
            data: this.dataTests
          },
          {
            label: this.$t('kiosks.graph.pre_contacts'),
            backgroundColor: '#a49d97',
            data: this.dataPreContacts
          },
          {
            label: this.$t('kiosks.graph.contacts'),
            backgroundColor: '#ea4e4e',
            data: this.dataContacts
          }
        ]
      }
      if (!this.kiosk.values || !this.kiosk.values['Contact']) {
        return data
      }
      this.updateKioskData()
      return data
    }
  },
  methods: {
    updateKioskData: function () {
      let date = this.moment(this.kiosk.from)
      this.labels.splice(0)
      if (!this.kiosk || !this.kiosk.values || !this.kiosk.values.Contact) {
        return
      }
      for (let i = 0; i < this.kiosk.values.Contact.length; i++) {
        this.labels.push(date.format('DD/MM'))
        date.add(1, 'days')
      }
      this.dataPresentations.splice(0)
      let values = this.kiosk.values['Questions']
      if (values) {
        this.dataPresentations.push(...values)
      }
      this.dataQuestions.splice(0)
      values = this.kiosk.values['Evaluation']
      if (values) {
        this.dataQuestions.push(...values)
      }
      this.dataTests.splice(0)
      values = this.kiosk.values['Result']
      if (values) {
        this.dataTests.push(...values)
      }
      this.dataPreContacts.splice(0)
      values = this.kiosk.values['Contact']
      if (values) {
        this.dataPreContacts.push(...values)
      }
      this.dataContacts.splice(0)
      values = this.kiosk.values['Thanks']
      if (values) {
        this.dataContacts.push(...values)
      }
    }
  },
  watch: {
    kiosk: function () {
      this.updateKioskData()
    }
  }
}
</script>

<style lang="scss">

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 40%;
  left: 50%;
}

</style>
